<template>
  <div class="home-banner">
    <app-menu :active.sync="menuOpen" :bottom="isFixedNavbar" />
    <div class="home-banner-content" ref="homeBannerContent">
      <img src="@/assets/img/svg/logo.svg" width="190">
      <h2>Qualidade, transparência e ética.</h2>
      <!-- <p>Direito trabalhista, previdenciário, cível, sindical e direito médico</p> -->
      <a class="home-banner-mouse" href="#main-content"></a>
    </div>
    <top-navbar class="home-banner-navbar" :is-fixed="isFixedNavbar" :menu-opened.sync="menuOpen" />
  </div>
</template>

<script>

import Menu from "@/components/Menu";
import TopNavbar from "@/components/Page/TopNavbar";
import { debounce } from "lodash";

export default {

    components: {
        'app-menu' : Menu,
        TopNavbar,
    },
    data() {
        return {
            menuOpen: false,
            isFixedNavbar: false,
        }
    },

    methods: {

        handleFixedNavbar: debounce(function () {

            const el = this.$refs.homeBannerContent;

            if (! el) return;

            const {top, height} = el.getBoundingClientRect();

            this.isFixedNavbar = height - 75 + top <= 0;

        }, 20)
    },


    watch: {
        menuOpen(active) {
            if (! this.isFixedNavbar && active) window.scrollTo(0, 0)
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleFixedNavbar, true);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleFixedNavbar);
        document.body.classList.remove('menu-opened')
    }
}
</script>

<style>

</style>
